// /settings/license container (docs/09-frontend-surface.md, "4. First-ship
// information architecture (routes)"; docs/04-api-contract.md, "5a. License
// status surface"; docs/08-on-prem-readiness.md, "XIV — Offline signed
// licensing"). Fetches the read-only license status and hands it to the
// presentational LicenseSettingsView. Data comes ONLY from
// GET /v1/system/license — no entitlement is inferred client-side. The shared
// query definition (lib/licenseQuery.ts) periodically refetches so a newly
// reached warning / grace / locked / 95% state surfaces without a reload.
import { useQuery } from "@tanstack/react-query";

import { licenseStatusQueryOptions } from "../lib/licenseQuery";
import { LicenseSettingsView } from "./LicenseSettingsView";

export function LicenseSettings() {
  const license = useQuery(licenseStatusQueryOptions());

  return (
    <LicenseSettingsView
      errorMessage={license.isError ? license.error.message : undefined}
      isPending={license.isPending}
      status={license.data}
    />
  );
}
